const modal = document.querySelector('.modal')
const body = document.querySelector('body')
const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

if(!iOS) {
  document
    .querySelectorAll('.modal_link')
    .forEach(anchor => {
      anchor.addEventListener('click', e => {
        e.preventDefault()
        
        const link = e.target.getAttribute('href')
        const objectEl = document.createElement('object')

        objectEl.classList.add('modal_object')
        objectEl.setAttribute('data', link) 

        modal.querySelector('.modal_content').appendChild(objectEl)
        modal.classList.add('active')
        body.style.overflow = 'hidden'
      })
    })

  modal
    .querySelector('.modal_close')
    .addEventListener('click', () => {
      modal.querySelector('.modal_object').remove()
      modal.classList.remove('active')
      body.style.overflow = 'visible'
    })
  }